import { render, staticRenderFns } from "./BaseNewsletterForm.vue?vue&type=template&id=076026ea&scoped=true&"
import script from "./BaseNewsletterForm.vue?vue&type=script&lang=js&"
export * from "./BaseNewsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076026ea",
  null
  
)

export default component.exports